// External Libraries
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

// UI Components
import FormField from '../../components/ui/FormField';
import CheckboxField from '../../components/ui/CheckboxField';
import MediaSelectorButton from '../../components/media/MediaSelectorButton';
import SubmitButton from '../../components/ui/SubmitButton';

// Redux Actions
import { addPartnerFunc } from '../../../store/custom-actions/partners-actions/AddPartnerSlicer';
import { getPartnersFunc } from '../../../store/custom-actions/partners-actions/GetPartnersSlicer';

function NewPartnerForm({ show, onHide }) {
  const { t } = useTranslation();
  const { register, reset, formState: { errors }, handleSubmit, setValue } = useForm();
  const { loading: submitLoading } = useSelector(state => state.addPartnerSlicer);
  const dispatch = useDispatch();

  const resetForm = () => {
    onHide();
    reset();
  };

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      is_active: data.is_active || false,
      sort_order: parseInt(data.sort_order) || 0,
    };
    
    const result = await dispatch(addPartnerFunc({ data: payload }));

    if (addPartnerFunc.fulfilled.match(result)) {
      dispatch(getPartnersFunc());
      resetForm();
    }
  };

  return (
    <>
      <Modal show={show} onHide={onHide} size="lg">
        <Modal.Header>
          <Modal.Title>{t('New Partner')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            id="submit-form-add"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="row">
              <div className="col-md-6">
                <FormField
                  label={t("Name")}
                  name="name"
                  register={register}
                  required={true}
                  errors={errors}
                  placeholder={t("Enter partner name")}
                />
              </div>
              <div className="col-md-6">
                <FormField
                  label={t("Sort Order")}
                  name="sort_order"
                  type="number"
                  register={register}
                  errors={errors}
                  placeholder={t("Enter sort order")}
                  min="0"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <MediaSelectorButton
                  label={t("Logo")}
                  inputName="logo_id"
                  register={register}
                  errors={errors}
                  onChange={(val) => setValue("logo_id", val)}
                />
              </div>
              <div className="col-md-6 d-flex align-items-end">
                <CheckboxField
                  name="is_active"
                  label={t("Active")}
                  register={register}
                  errors={errors}
                  defaultChecked={true}
                />
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            {t('Close')}
          </Button>
          <SubmitButton
            isLoading={submitLoading}
            form="submit-form-add"
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default NewPartnerForm;
